import { getDebugLogger } from '~publish/legacy/utils/getDebugLogger'

export const editorDebug = getDebugLogger('editor')
